import React, { useState } from "react";
import { Box, Typography, Switch, Divider } from "@mui/material";
import Form from "react-bootstrap/Form"; // ✅ Required for Form.Check

const HeadingSx = {
  color: "var(--color-grey-6, rgba(15, 15, 15, 1))",
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "20px",
  letterSpacing: 0,
  verticalAlign: "middle",
};
const SubTextSx = {
  color: "var(--color-grey-38, rgba(96, 96, 96, 1))",
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: 14,
  lineHeight: "20px",
  letterSpacing: 0,
  verticalAlign: "middle",
};

const SupportFeedbackSettings = () => {
  const [toggles, setToggles] = useState({
    contactSupport: false,
    reportBug: true,
    submitFeedback: false,
    termsPrivacy: true,
    collaborationMilestones: true,
  });

  const handleToggle = (key) => {
    setToggles((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const settingsList = [
    {
      title: "Contact Support",
      description:
        "Reach out to our support team directly for technical issues, account help, or urgent concerns.",
      key: "contactSupport",
    },
    {
      title: "Report a Bug",
      description:
        "Spotted something not working? Let us know so we can fix it fast and improve your experience.",
      key: "reportBug",
    },
    {
      title: "Submit Feedback",
      description:
        "Have suggestions or ideas? Share your thoughts to help us shape a better platform for creators and brands.",
      key: "submitFeedback",
    },
    {
      title: "Terms of Service & Privacy Policy",
      description:
        "Review the rules that govern your use of the platform and how your data is handled.",
      key: "termsPrivacy",
    },
    {
      title: "Collaboration Milestones",
      description:
        "Receive notifications for key steps like content submissions, deadlines, or approvals.",
      key: "collaborationMilestones",
    },
  ];
  return (
    <>
      {" "}
      <Box
        p={3}
        sx={{
          width: "100%",
          height: "100vh",

          // maxWidth: 700,
          borderRadius: 2,
          border: "1px solid rgba(221, 221, 221, 1)",
          boxShadow: 0,
          mt: 2,
          // m: "auto",
        }}
      >
        {settingsList.map((item, index) => (
          <Box key={item.key} mb={index < settingsList.length - 1 ? 2 : 0}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <Box>
                <Typography sx={HeadingSx}>{item.title}</Typography>
                <Typography sx={SubTextSx}>{item.description}</Typography>
              </Box>
              <Form.Check
                type="switch"
                checked={toggles[item.key]}
                onChange={() => handleToggle(item.key)}
              />
            </Box>
            {index < settingsList.length - 1 && <Divider sx={{ mt: 2 }} />}
          </Box>
        ))}
      </Box>
    </>
  );
};

export default SupportFeedbackSettings;
